import React from "react";
import { Panel } from "../../components/panels";
import { NoDataAvailableDiv } from "../../components/NoDataAvailableDiv";
import AdminOneClientCard from "./AdminOneClientCard";

interface Props {
  config: server.dto.RelatedAdminOneClientPanelConfig
}

const AdminOneClientsByCompanyPanel = (props: Props) => {
  return (<Panel
    panelClassName="s1_related-feature-panel"
    title={props.config.headerLabel}>
    {(props.config.linkedClients.length === 0) && <NoDataAvailableDiv>No matching client found.</NoDataAvailableDiv>}

    {props.config.linkedClients.map((client) => <AdminOneClientCard
      key={`client_${client.clientId}`}
      client={client}
    />)
    }
  </Panel>);
};

export default AdminOneClientsByCompanyPanel;